<template>
  <div class="page_all">
    <loading
      :active.sync="isLoading"
      :on-cancel="onCancel"
      :is-full-page="fullPage"></loading>
    <div class="return_link"></div>
    <div class="page_header">
      <div class="header_title">
        <div class="title">地域</div>
        <div class="area_checkboxs_div">
          <div class="area_checkbox_div">
            <input class="area_checkbox" id="en_check" type="checkbox" v-model="checkNameEi">
            <label class="form-check-label area_check_label" for="en_check">英語</label>
          </div>
          <div class="area_checkbox_div">
            <input class="area_checkbox" id="kan_check" type="checkbox" v-model="checkNameKan" @change="onChangeKan">
            <label class="form-check-label area_check_label" for="kan_check">韓国語</label>
          </div>
          <div class="area_checkbox_div">
            <input class="area_checkbox" id="chu_han_check" type="checkbox" v-model="checkNameChuHan">
            <label class="form-check-label area_check_label" for="chu_han_check">中国語(繁体字)</label>
          </div>
          <div class="area_checkbox_div">
            <input class="area_checkbox" id="chu_kan_check" type="checkbox" v-model="checkNameChuKan">
            <label class="form-check-label area_check_label" for="chu_kan_check">中国語(簡体字)</label>
          </div>
        </div>
      </div>
      <div>
        <button class="btn_general" v-on:click="open_modal_deleteAllArea()">全件削除</button>
        <modal name="modal_deleteAllArea" :draggable="false" :resizable="false" :height="200">
          <div class="modal_header">
            <p class="modal_title">地域を全件削除してよろしいですか？</p>
          </div>
          <div class="modal-body">
            <div class="modal_string_div">
              <span class="modal_string string_red">注意：設定されている全ての地域が完全に削除されます。</span>
            </div>
            <div class="modal_btn_div">
              <button  class="btn btn-outline-primary modal_btn" @click="close_modal_deleteAllArea">キャンセル</button>
              <button class="btn btn-outline-primary" v-on:click="open_modal_deleteAllArea2()">削除</button>
            </div>
          </div>  
        </modal>
        <modal name="modal_deleteAllArea2" :draggable="false" :resizable="false" :height="200">
          <div class="modal_header">
            <p class="modal_title">地域を全件削除します、本当によろしいですか？</p>
          </div>
          <div class="modal-body">
            <div class="modal_string_div">
              <span class="modal_string string_red">注意：削除を選択で処理が実行されます。</span>
            </div>
            <div class="modal_btn_div">
              <button  class="btn btn-outline-primary modal_btn" @click="close_modal_deleteAllArea2">キャンセル</button>
              <button class="btn btn-outline-primary" v-on:click="deleteAllArea()">削除</button>
            </div>
          </div>  
        </modal>
        <button class="btn_general" v-on:click="csv_modal_open()">csv取り込み</button>
        <modal name="modal_csv" :draggable="false" :resizable="false" :height="400">
          <div class="modal_header_csv">
            CSV取り込み
          </div>
          <div class="modal_title_div">
            <p class="modal_title">取り込みを行うCSVを設定してください</p>
            <div class="csv_btn">
              <label class="csv_btn_label btn btn-outline-secondary">
                csvの設定
                <input class="csv_input" type="file" @change="onCsvChange" accept=".csv" />
              </label>
            </div>
            <div>
              <p v-if="csvName == ''"><br></p>
              <p>{{ csvName }}</p>
            </div>
          </div>
          <div class="modal-body">
            <div>
              <ul class="csv_ul">
                <li>csvファイルは文字コードがUTF-8になってる必要があります。下記テンプレートをダウンロードしてご利用ください。</li>
                <li>地域の登録画面と同様に町丁目名に半角スラッシュ(/)を記入することで、アプリ上で階層を分けて表示されます。</li>
              </ul>
            </div>
            <div class="dl_btn_div_csv">
              <div>
                <button class="btn btn-outline-secondary dl_btn" @click="downloadTemplateCsv">テンプレートのダウンロード</button>
              </div>
              <div>
                <button class="btn btn-outline-secondary dl_btn" @click="downloadSampleCsv">サンプルファイルのダウンロード</button>
              </div>
            </div>
          </div>  
          <div class="modal_btn_div_csv">
            <!-- <button class="btn btn-outline-primary modal_btn" :disabled="areaCsvFile == ''" v-on:click="importMstMunicipality">自治体マスターcsv取り込み</button> -->
            <button class="btn btn-outline-primary modal_btn" :disabled="areaCsvFile == ''" v-on:click="open_modal_import_csv">csv取り込み</button>
            <button  class="btn btn-outline-primary" @click="close_modal_csv">キャンセル</button>
          </div>
        </modal>
        <modal name="modal_import_csv" :draggable="false" :resizable="false" :height="200">
          <div class="modal_header">
            <p class="modal_title">CSVファイルの取り込みを行います、よろしいですか？</p>
          </div>
          <div class="modal-body">
            <div class="modal_string_div">
              <span class="modal_string">*CSVファイルの取り込みを行うと、現在設定されている地域に追加で取り込まれます。</span>
            </div>
            <div class="modal_btn_div">
              <button  class="btn btn-outline-primary modal_btn" @click="close_modal_import_csv">キャンセル</button>
              <button class="btn btn-outline-primary" v-on:click="importAreaCsv()">取り込み</button>
            </div>
          </div>  
        </modal>
        <button class="btn_general" v-on:click="sort_modal_open()">一括並び替え</button>
        <modal name="modal_release" :draggable="false" :resizable="false" :height="200">
          <div class="modal_header">
            <p class="modal_title">地域の一括並び替えを行います。</p>
          </div>
          <div class="modal-body">
            <div class="modal_string_div">
              <span class="modal_string">町丁目(フリガナ)の昇順に並び替えを行います、よろしいですか？</span>
              <p class="modal_string">*アプリ側にも並び替えが反映されます。</p>
            </div>
            <div class="modal_btn_div">
              <button  class="btn btn-outline-primary modal_btn" @click="close_modal_release">キャンセル</button>
              <button class="btn btn-outline-primary" v-on:click="sort()">並び替え</button>
            </div>
          </div>  
        </modal>
        <button class="btn_plus" v-on:click="areaAdd()">＋</button>
      </div>
    </div>
    <div v-if="message != ''" class="message">
      <div class="error">{{ message }}</div>
    </div>
    <div class="notes">
      <p class="notes_p">＊設定がない項目の場合は、プライマリー言語の内容をアプリに表示します。</p>
      <p class="notes_p">プライマリー言語に設定がない場合は、日本語の内容を表示します。</p>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="h_area">町丁目名</th>
            <th v-if="checkNameEi" class="h_area">町丁目名<br>(英語)</th>
            <th v-if="checkNameKan" class="h_area">町丁目名<br>(韓国語)</th>
            <th v-if="checkNameChuHan" class="h_area">町丁目名<br>(中国語:繁体字)</th>
            <th v-if="checkNameChuKan" class="h_area">町丁目名<br>(中国語:簡体字)</th>
            <th class="h_area">町丁目(フリガナ)</th>
            <th class="h_area">地域グループ</th>
            <th class="h_area">町丁目コード</th>
            <th class="h_mytimeline">マイタイムライン</th>
            <th class="h_updown" colspan="2">並び替え</th>
            <th class="h_delete">削除</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(area, index) in areas" v-bind:key="area.area_id">
            <td class="td_area">
              <router-link v-on:click.native="areaUpdate(area.area_id, area.area_name)" to="">{{ area.area_name }}</router-link>
            </td>
            <td v-if="checkNameEi" class="td_area">
              {{ area.area_name_ei}}
            </td>
            <td v-if="checkNameKan" class="td_area">
              {{ area.area_name_kan}}
            </td>
            <td v-if="checkNameChuHan" class="td_area">
              {{ area.area_name_chu_han}}
            </td>
            <td v-if="checkNameChuKan" class="td_area">
              {{ area.area_name_chu_kan}}
            </td>
            <td class="td_area">
              {{ area.area_furigana}}
            </td>
            <td class="td_area">
              {{ area.group_name}}
            </td>
            <td class="td_area">
              {{ area.area_code}}
            </td>
            <td class="td_mark">
              <div class="mark_box">
                <div class="mark_outer" v-for="disaster in area.disaster_type" v-bind:key="disaster.id">
                  <div class="mark_inner" id="color_box" v-bind:style="{backgroundColor: 'rgb(' + disaster.mark_color + ')'}">
                    <a>{{disaster.disaster_name}}</a>
                  </div>
                </div>
              </div>
            </td>
            <td class="btn_up">
              <div v-if="index > 0">
                <button class="btn_updown" v-on:click="areaUp(area.municipality_key, area.area_id, area.sort_no)">▲</button>
              </div>
              <div v-else>
                <div class="btn_disable">▲</div>
              </div>
            </td>
            <td class="btn_down">
              <div v-if="index == areas.length-1">
                <div class="btn_disable">▼</div>
              </div>
              <div v-else>
                <button class="btn_updown" v-on:click="areaDown(area.municipality_key, area.area_id, area.sort_no)">▼</button>
              </div>
            </td>
            <td class="btn_delete">
              <button v-if="areas.length > 1" class="btn_delete" v-on:click="areaDel(area.municipality_key, area.area_id, area.sort_no)">X</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <confirm-dialog ref="deleteDialog" modal-width='620' primary-label="削除" secondary-label="キャンセル"/>
  </div>
</template>

<script>
import ConfirmDialog from "@/components/ConfirmDialog";

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    ConfirmDialog,
    "loading":Loading
  },
  data: function() {
    return {
      areas: null,
      // メッセージ
      message: "",
      csvName: "",
      areaCsvFile: "",

      innerCheckNameEi: sessionStorage.getItem('checkNameEi') != null ? sessionStorage.getItem('checkNameEi') === "true" : "",
      checkNameKan: sessionStorage.getItem('checkNameKan') != null ? sessionStorage.getItem('checkNameKan') === "true" : "",
      innerCheckNameChuHan: sessionStorage.getItem('checkNameChuHan') != null ? sessionStorage.getItem('checkNameChuHan') === "true" : "",
      innerCheckNameChuKan: sessionStorage.getItem('checkNameChuKan') != null ? sessionStorage.getItem('checkNameChuKan') === "true" : "",

      isLoading: false,
      fullPage: true      
    }
  },
  mounted() {
    // sessionStorage.clear()
    // console.log(sessionStorage.getItem('checkNameEi') != null ? sessionStorage.getItem('checkNameEi') : "")
    console.log(this.checkNameKan)
    // console.log(this.$store.getters.getStateMunicipalityKey)
    this.getAreaList()
  },
  methods: {
    async getAreaList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
        }
      })
      this.areas = response.data
      console.log(this.areas)
    },
    async areaUp(municipality_key, area_id, sort_no) {
      await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area/up', {
        params: {
          municipality_key: municipality_key,
          area_id: area_id,
          sort_no: sort_no
        }
      })
      this.getAreaList()
    },
    async areaDown(municipality_key, area_id, sort_no) {
      await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area/down', {
        params: {
          municipality_key: municipality_key,
          area_id: area_id,
          sort_no: sort_no
        }
      })
      this.getAreaList()
    },
    async areaDel(municipality_key, area_id, sort_no) {
      const area = this.areas && this.areas.find(area => area.area_id === area_id) || null;
      if (!area) {
        return;
      }
      const result = await this.$refs.deleteDialog.asyncShow(`${area.area_name}を削除してよろしいですか？`);
      if (!result) {
        return;
      }
      this.isLoading = true
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'area/del', {
          municipality_key: municipality_key,
          area_id: area_id,
          sort_no: sort_no,
          charge_id: this.$store.getters.getStateChargeId
        })
        this.message = ""
        this.getAreaList()
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
      this.isLoading = false
    },
    areaAdd: function() {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', false)
      this.$router.push({ name: 'areaDetail' })
    },
    areaUpdate: function(area_id) {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', true)
      // 地域コードをStoreにセット
      this.$store.commit('setStateAreaId', area_id)
      this.$router.push({ name: 'areaDetail' })
    },
    async sort() {
      this.isLoading = true
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'area/list-action', {
          action_name: "sort"
        })
        this.getAreaList()
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
      this.isLoading = false

      this.close_modal_release()
    },
    downloadTemplateCsv: function() {
      this.downloadFile("downloadCsv", "areatemplate.csv", "text/csv")

      this.close_modal_csv()
    },
    downloadSampleCsv: function() {
      this.downloadFile("downloadCsv", "areasample.csv", "text/csv")

      this.close_modal_csv()
    },
    async downloadFile(actionName, fileName, fileHeader) {
      const {response, error} = await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'area/list-action', {
        action_name: actionName,
        file_name: fileName
      }, {
        headers: {
          'Accept': fileHeader,
        },
        responseType: "blob",
      }).then(response => ({response}))
      .catch(error => ({error}));
      // this.downloading = false;
      if (error) {
        this.message = error;
        return null;
      }

      const blob = new Blob([response.data], {type: response.headers["content-type"]});
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href)
      }

    },
    async importAreaCsv() {
      await this.importCsv(this.areaCsvFile, "importAreaCsv")

      this.getAreaList()
      this.close_modal_import_csv()
    },
    async importMstMunicipality() {
      await this.importCsv(this.areaCsvFile, "import_mst_municipality")

    },
    async importCsv(file, actionName) {
      if (file != "" || file != null) {
        var toBase64 = file => new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        })
      }
      const data = {
        "file": (await toBase64(file)).replace(/data:.*\/.*;base64,/, ''),
        "file_type": file.type,
        "action_name" : actionName,
        "municipality_key" : this.$store.getters.getStateMunicipalityKey
      }
      this.isLoading = true
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'area/list-action'
                                                        , data
                                                        , {headers: {'Content-Type': "test/json"},})
        this.message = ""
      } catch (err) {
         this.message = err.response.data.errorMessage
      }
      this.isLoading = false
    },
    async deleteAllArea() {
      this.isLoading = true
      const {response, error} = await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'area/list-action', {
        action_name: "deleteAllArea",
        areas: this.areas
      }).then(response => {
        this.message = ""
        return ({response})
      }
        )
      .catch(error => ({error}));
      // this.downloading = false;
      if (error) {
        this.message = error.response.data.errorMessage
        return null;
      }
      this.isLoading = false

      this.getAreaList()
      this.close_modal_deleteAllArea2()

      return response.data
    },
    onCsvChange: function(e) {
      const files = e.target.files || e.dataTransfer.files;
      this.areaCsvFile = files[0]
      this.csvName = files[0].name;      
    },
    sort_modal_open: function() {
      this.$modal.show("modal_release")
    },
    close_modal_release: function() {
      this.$modal.hide("modal_release")
    },
    csv_modal_open: function() {
      this.areaCsvFile = ""
      this.csvName = ""
      this.$modal.show("modal_csv")
    },
    close_modal_csv: function() {
      this.$modal.hide("modal_csv")
    },
    open_modal_import_csv: function() {
      this.$modal.hide("modal_csv")
      this.$modal.show("modal_import_csv")
    },
    close_modal_import_csv: function() {
      this.$modal.hide("modal_import_csv")
    },
    open_modal_deleteAllArea: function() {
      this.$modal.show("modal_deleteAllArea")
    },
    close_modal_deleteAllArea: function() {
      this.$modal.hide("modal_deleteAllArea")
    },
    open_modal_deleteAllArea2: function() {
      this.$modal.hide("modal_deleteAllArea")
      this.$modal.show("modal_deleteAllArea2")
    },
    close_modal_deleteAllArea2: function() {
      this.$modal.hide("modal_deleteAllArea2")
    },
    onCancel:function() {
      console.log('User cancelled the loader.')
    },
    onChangeKan: function(event) {
      this.checkNameKan = event.target.checked
      sessionStorage.setItem('checkNameKan', this.checkNameKan)
    }
  },
  computed: {
    checkNameEi: {
      get() {
        return this.innerCheckNameEi
      },
      set(value) {
        this.innerCheckNameEi = value
        sessionStorage.setItem('checkNameEi', value)
      }
    },
    checkNameChuHan: {
      get() {
        return this.innerCheckNameChuHan
      },
      set(value) {
        this.innerCheckNameChuHan = value
        sessionStorage.setItem('checkNameChuHan', value)
      }
    },
    checkNameChuKan: {
      get() {
        return this.innerCheckNameChuKan
      },
      set(value) {
        this.innerCheckNameChuKan = value
        sessionStorage.setItem('checkNameChuKan', value)
      }
    }
  }
}
</script>

<style scoped>
.message {
  white-space: pre-wrap;
}
.area_checkboxs_div {
  margin: 0 0 0 20px;
  display: flex;
}
.area_checkbox_div {
  margin: 0 10px 0 0 ;
}
.area_checkbox {
  margin: 0 3px 0 0;
}
.area_check_label {
  font-size: smaller;
}
.page_all {
  width: 1100px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}
.page_all_wide {
  width: 1200px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}
.tbl_main {
  width: 1100px;
  border: 1px #666666 solid;
  border-collapse: collapse;
}
.tbl_main_wide {
  width: 1200px;
  border: 1px #666666 solid;
  border-collapse: collapse;
}
.btn_general {
  margin: 0 20px 0 0;
  height: 30px;
  width: 100px;
}
table th.h_area {
  width: 112px;
}
table th.h_mytimeline {
  width: 178px;
}
table th.h_updown {
  width: 60px;
}
table th.h_delete {
  width: 50px;
}
table td {
  word-break: break-all;
}
table td.td_area {
  text-align: left;
  padding-left: 10px;
}

.mark_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  padding: 10px 10px 0px 0px;
  max-width: 178px;
}
.mark_outer {
  display: table;
  margin: 0px 0px 10px 10px;
}
.mark_inner {
  background-color: rgb(192,192,192);
  width: 45px;
  height: 45px;
  text-align: center;
  font-family: Arial;
  display: table-cell;
  vertical-align: middle;
  border-radius: 7px 7px 7px 7px;
  color: #F4F4F4;
}

.btn_up {
  text-align: right;
  font-size: 15px;
  border-right: none;
  width: 30px;
}
.btn_down {
  text-align: left;
  font-size: 15px;
  border-left: none;
  width: 30px;
}
.btn_delete {
  text-align: center;
  border-left: none;
  width: 20px;
}
.btn_updown {
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
}
.modal_header_csv {
  text-align: left;
  margin: 10px 0 20px 20px;
}
.modal_header {
  margin: 10px 0 20px 20px;
}
.modal_body {
}
.modal_title_div {
  text-align: left;
  font-size: small;
  padding: 10px 0 0 20px;
  border-bottom: 1px solid #ddd;
}
.csv_ul {
  text-align: left;
  font-size: smaller;
  margin: 0 0 0 -20px;
}
.dl_btn_div_csv {
  text-align: left;
}
.dl_btn {
  margin-top: 5px;
  width: 250px;
  font-size: small;
}
.modal_string_div {
  height: 50%;
}
.modal_string {
  font-size: small;
}
.string_red {
  color: red;
}
.modal_btn_div_csv {
  height: 50%;
  text-align: right;
  margin-right: 10px;
}
.modal_btn_div {
  height: 50%;
  margin-top: 20px;
}
.modal_btn {
  margin: 0 10px 0 0;
}
.csv_btn {

}
.csv_btn_label {
  padding: 0 1rem;
  border: solid 1px #888;
  border-radius: 0.25rem;
  cursor: pointer;
}
.csv_input {
  display: none;
}
.notes {
  text-align: left;
  margin: 20px 0 30px 0 
}
.notes_p {
  font-size: smaller;
  line-height: 0.4;
}
</style>